import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteMessages, type DeleteMessagesResponse } from "~/entities/chat";
import { chatJobsKey, chatMessagesKey } from "~/entities/chat/useActiveChat";
import { workspaceKeys } from "~/entities/workspace";
import { chatListKey } from "~/entities/chat/useChats";

interface DeleteMessagesVars {
    chatId: string;
    // Workspace чата — для инвалидации списка чатов (чат мог быть удалён).
    workspaceId: string;
    messageIds: string[];
    // Soft-удалить чат, если он опустел после удаления.
    deleteChatIfEmpty?: boolean;
}

// После жёсткого удаления инвалидируем чат целиком (сообщения +
// job-снимки + generated-artifacts) и список чатов/registry — чат мог опустеть
// или быть удалён. Баланс workspace вырос (refund) — SSE-баланс подключён только
// на странице биллинга, поэтому сайдбар обновляем инвалидацией по префиксу
// ["workspace","balances"] (накрывает и точечный ключ, и batch у свитчера).
export function useDeleteMessages() {
    const qc = useQueryClient();
    return useMutation<DeleteMessagesResponse, Error, DeleteMessagesVars>({
        mutationFn: ({ chatId, messageIds, deleteChatIfEmpty }) =>
            deleteMessages(chatId, { messageIds, deleteChatIfEmpty }),
        onSuccess: (_res, vars) => {
            void qc.invalidateQueries({ queryKey: chatMessagesKey(vars.chatId) });
            void qc.invalidateQueries({ queryKey: chatJobsKey(vars.chatId) });
            void qc.invalidateQueries({ queryKey: ["v2", "chat", vars.chatId, "generated-artifacts"] });
            void qc.invalidateQueries({ queryKey: chatListKey(vars.workspaceId) });
            void qc.invalidateQueries({ queryKey: ["v2", "chats", "registry"] });
            void qc.invalidateQueries({ queryKey: workspaceKeys.balances(vars.workspaceId).slice(0, 2) });
        },
    });
}
